import { useState, useEffect, useRef } from "react";
import { Row, Button, Divider, Tabs, Modal, message, Select, Col, Typography } from "antd";
import French from "@uppy/locales/lib/fr_FR";
import English from "@uppy/locales/lib/en_US";
import Files from "../utils/Files";
import {
  YoutubeFilled,
  PlayCircleFilled,
  FolderAddFilled,
  CameraFilled,
  LinkOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "@uppy/core/dist/style.css";
import "@uppy/drag-drop/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import "@uppy/status-bar/dist/style.css";
import { AddHooks } from "../utils/hooks";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useDataTablePendingVideo from "./pendingVideoTable";
import { useAppSelector } from "../../redux/hooks";
import { DataPendingVideosTable } from "../data/dataVideosPending";
import Uppy from "@uppy/core";
import Tus from "@uppy/tus";
import { useTranslation } from "react-i18next";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import i18next from "i18next";
import Cookies from "js-cookie";
import { AddUrl } from "./AddUrl";

import {
  setAddMediaActions,
  setIdVideoAdded,
  setLoading,
  setTabClicked,
} from "../store/addMediaActions";
import Loader from "../../components/Loader";
import { StatusBar, DragDrop } from "@uppy/react";
import LoadingScreen from "../../Podcast/utils/LoadingScreen";
const { Text } = Typography;

export const ExportVideo = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { columns, data } = DataPendingVideosTable();

  const { DataTable } = useDataTablePendingVideo({
    columns: columns,
    dataSource: data,
  });
  const [isMultipleMode, setIsMultipleMode] = useState(false);
  const [isTusUploadComplete, setIsTusUploadComplete] = useState(false);
const [audioTypes, setAudioTypes] = useState({});
const [multiUploadedFiles, setMultiUploadedFiles] = useState([]);

  const [fileCountUpload, SetfileCountUpload] = useState(0);
  const [defaultKey, setdefaultKey] = useState("1");
  const [currentuploading, setcurrenUploading] = useState(0);
  const [listtoupload, setlisttoupload] = useState([]);
  const [, setisFinishedUpload] = useState(false);
  const [automaticAdd, setautomaticAdd] = useState(false);
  const [loaderLoading, setLoaderLoading] = useState(false);
  const messageCatchCurrupted = (() => message.error(`Cette vidéo est corrompue `))
  const isMultipleModeRef = useRef(false);
  const handleChange = (e) => {
    const { checked } = e.target;
    setautomaticAdd(checked);
  };
  useEffect(() => {
    isMultipleModeRef.current = isMultipleMode;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMultipleMode]);
  useEffect(() => {
    return () => {
      uppy.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    localStorage.setItem("automaticAdd", automaticAdd);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [automaticAdd]);

  function makeid(length) {
    let result = "";
    let characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  const error = () => {
    Modal.error({
      title: "Réssayer ultérieurement",
      content: "Une erreur s'est produite de notre côté ",
    });
  };
  const removeSpecialCharFromName = (name) => {
    return name
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[&/\\#,+()$~%.'":*?<>{}^;]/g, "")
        .replace(/\s+/g, "_")
        .replace(/[^\x20-\x7E]/g, "");
  }

  const uppyRef = useRef(null);

  if (!uppyRef.current) {
    uppyRef.current = new Uppy({
      debug: true,
      locale: i18next.language === "en" ? English : French,
      id: "uppy",
      restrictions: {
        maxNumberOfFiles: 1,
        allowedFileTypes: [
          ".mp4",
          ".flv",
          ".m4v",
          ".avi",
          ".flv",
          ".wmv",
          ".mpeg",
          ".mpg",
          ".mpe",
          ".dat",
          ".vob",
          ".asf",
          ".asx",
          ".mov",
          ".3gp",
          ".3g2",
          ".3gpp",
          ".dv",
          ".qt",
          ".rm",
          ".webm",
          ".mkv"
        ],
        },
  
        onBeforeUpload: (files) => {
          const updatedFiles = Object.assign({}, files);
          Object.keys(updatedFiles).forEach((fileId) => {
            let lastDotPosition = updatedFiles[fileId].name.lastIndexOf(".");
            let name = updatedFiles[fileId].name.slice(0, lastDotPosition);
            name = removeSpecialCharFromName(name);
            let ext = updatedFiles[fileId].name.slice(
              lastDotPosition,
              updatedFiles[fileId].name.length
            );
            let filename = name + makeid(5) + ext;
            const changeSourceHeaders =
              query.get("changeSource") === "true"
                ? {
                  "upload-type": "change-source",
                  "video-id": query.get("id"),
                  "media-id": query.get("mediaid"),
                  token: query.get("fileName").split(".")[0],
                }
                : {};
            let headers = {
              "automatic-add":
                query.get("changeSource") === "true" ? false : automaticAdd,
              Authorization: "Bearer " + Cookies.get("authToken"),
              autoUpload: false,
              filename:
                query.get("changeSource") === "true"
                  ? query.get("fileName")
                  : filename,
                  "client-name": window.process.env.CLIENT_NAME,

              ...changeSourceHeaders,
              ...(window?.process?.env?.FO_CLIENT
                ? { bucketName: window.process.env.FO_CLIENT }
                : {}),    
"upload-mode": isMultipleModeRef.current ? "multiple" : "single",
"audio-type": isMultipleModeRef.current ? audioTypes[fileId] || "" : "",

            };
      
            updatedFiles[fileId].tus = {
              headers: headers,
            };
          });
          return updatedFiles;
        },
        autoProceed: true,

      });
    
  
    uppyRef.current.use(Tus, {
      id:"tus",
      chunkSize: 1024 * 1024 * 50,
      endpoint: `${window.process.env.API_HOST_UPLOAD}${query.get("changeSource") ? "videos/change-source" : "videos/upload-video"
      }`,
      removeFingerprintOnSuccess: true,
      async onAfterResponse(req, res) {
        res?.getBody() && Files.setToken(res?.getBody());
        res?.getBody() && Files.setVideoId(res?.getBody());
      },
    });
  }
  
  const uppy = uppyRef.current;




  const handleSingleUpload = async (result) => {

    if (result?.successful?.length) {
      let videoToken = Files.getToken();
      let tokensData = [{ token: videoToken }];

      dispatch(
          setAddMediaActions({
              addMediaConstraintsDataNameChange: "tokens",
              addMediaConstraintsDataValueChange: tokensData,
          })
      );
      let videoId = Files.getVideoId();
      let filename = result?.successful[0]?.tus?.headers?.filename;


      dispatch(setIdVideoAdded(videoId));
      if (automaticAdd) {
          history.push("/ws-media/medias");
      } else {
          if (query.get("changeSource") === "true" && videoToken) {
              return history.push("/ws-media/medias");
          }
          setLoaderLoading(true);

          let metadataSuccess = false; 
          try {
              await getMetaData(videoId, filename, false);
              metadataSuccess = true;
          } catch (error) {
              setLoaderLoading(false);

              messageCatchCurrupted()
          }
          if (metadataSuccess) {
            
              try {
                  await getThumbs(filename);
                  setLoaderLoading(false);
                  if(!isMultipleMode){
                    videoToken 
                    ? history.push({
                        pathname:  `/ws-media/secondpageupload/video/${filename}/${videoId}`,
                        state: { id: data, videoId: videoId },
                    })
                    : error();
                  }
       
              } catch (error) {
                  console.error("Error getting thumbs:", error);
              }
          }
      }
      setisFinishedUpload(true);
      setcurrenUploading(currentuploading + 1);
      setlisttoupload([
          ...listtoupload,
          {
              fileName: result?.successful[0]?.name,
              size: result?.successful[0]?.size,
              id: fileCountUpload + 1,
          },
      ]);
      setisFinishedUpload(true);
      SetfileCountUpload(fileCountUpload + 1);
  }

  };
  const handleMultipleSubmit = () => {
    const files = uppy.getFiles();
    let filename = files[0]?.tus?.headers?.filename;
    for (let file of files) {
      if (!audioTypes[file.id]) {
        return message.error(`Sélectionnez le type audio pour ${file.name}`);
      }
    }
  
    const payload = files.map((file) => ({
      token: file?.tus?.headers?.filename,
      audioType: audioTypes[file.id],
      name: file.name,
    }));

    dispatch(
      setAddMediaActions({
        addMediaConstraintsDataNameChange: "multiTokens",
        addMediaConstraintsDataValueChange: payload,
      })
    );
  
history.push({
                          pathname: `/ws-media/secondpageupload/video/${filename}/multiple`,
                          state: { id: data, videoId: undefined },
                      })  };


  useEffect(() => {
 
  
    const handleComplete = async (result) => {
      setIsTusUploadComplete(true)
      if (!result?.successful?.length) return;
      await handleSingleUpload(result);

      if (isMultipleMode) {
        setMultiUploadedFiles(result.successful);
      } 
    };
  
    const handleUploadError = () => {
      Object.keys(localStorage).forEach((ls) => {
        if (ls.includes("tus")) localStorage.removeItem(ls);
      });
      dispatch(setLoading(false));
    };
  
    uppy.on("complete", handleComplete);
    uppy.on("upload-error", handleUploadError);
  
    return () => {
      uppy.off("complete", handleComplete);
      uppy.off("upload-error", handleUploadError);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMultipleMode]);
  // uppy.on("restriction-failed", (file, error) => {
  //   console.log('messagein1')
  //   message.error(`${error}`);
  // });

  useEffect(() => {
    dispatch(setTabClicked(0));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const modules = useSelector((state) => state.ReducerUserData.modules);
  const isSuperAdmin = useSelector(
    (state) => state.ReducerUserData.isSuperAdmin
  );

  const loading = useSelector((state) => state.ReducerUserData.loading);

  const handleUploadModeChange = (e) => {
    const checked = e.target.checked;
    setIsMultipleMode(checked);
  
    uppy.setOptions({
      restrictions: {
        ...uppy.opts.restrictions,
        maxNumberOfFiles: checked ? 10 : 1,
      },
    });
  };
  const {
    getMetaData,
    getThumbs
  } = AddHooks();
  const history = useHistory();
  const storyboardURL = useAppSelector(
    (state) => state.addMediaReducer.storyboard
  );

  const onKeyChange = (key) => {
    setdefaultKey(key);
    dispatch(setTabClicked(key));
  };
  const { TabPane } = Tabs;
  const exportType = [
    {
      id: 1,
      title: `${t("video.Importer")}`,
      icon: <FolderAddFilled />,
      permission: true,
      value: (
        <>
        <Loader loaderStatus={loaderLoading} />
        <div className="upload_header">
        <h2>{t("video.importer_fichiers")}</h2>
      
      {/* Multiple Mode Checkbox */}
      {modules?.multiple_video_upload && <FormControlLabel
        control={
          <Checkbox
            checked={isMultipleMode}
            onChange={handleUploadModeChange}
          />
        }
        label={t("video.multiple_mode")}      />}

        </div>
     
      
        <DragDrop
          id="dragdrop"
          uppy={uppy}
          locale={{
            strings: {
              dropHereOr: t("video.Select_files"),
            },
          }}

          inline={true}
          metaFields={[]}
          replaceTargetContent={true}
          note={t("video.noteupload")}
          target={document.body}
          proudlyDisplayPoweredByUppy={false}
          showProgressDetails
          showSelectedFiles
        />

        <StatusBar
          uppy={uppy}
          hideUploadButton
          hideAfterFinish={false}
          showProgressDetails
        />
          {/* Automatic Add (only single mode) */}
          {query.get("changeSource") === "true" ? null : 
        !isMultipleMode?
        (
          <FormControlLabel
            className="input"
            control={<Checkbox />}
            checked={automaticAdd}
            name={"automaticAdd"}
            onChange={handleChange}
            label= {modules?.media_video_list_dtable_videos_draft ? t("Podcast.draft_upload") : t("Podcast.Automatic upload")  }
          />

        ):null}
        {/* Audio selectors (Multiple mode only) */}
        {(isTusUploadComplete && isMultipleMode) &&
  uppy.getFiles().map((file) => (
    <Row key={file.id} style={{ marginTop: 10 }} align="middle">
      <Col span={8}>
        <Text>{file.name}</Text>
      </Col>

      <Col span={16}>
        <Select
          value={audioTypes[file.id] || ""}
          onChange={(value) =>
            setAudioTypes({
              ...audioTypes,
              [file.id]: value,
            })
          }
          style={{ width: '100%' }}
          placeholder={t("video.select_audio_track")}        >
          <Select.Option value="">  {t("video.select_audio_track")}
          </Select.Option>
          <Select.Option value="or">
  {t("video.audio_original")}
</Select.Option>

<Select.Option value="fr">
  {t("video.audio_fr")}
</Select.Option>

<Select.Option value="en">
  {t("video.audio_en")}
</Select.Option>
<Select.Option value="es">
  {t("video.audio_es")}
</Select.Option>    
<Select.Option value="ar">
  {t("video.audio_ar")}
</Select.Option>

<Select.Option value="zh">
  {t("video.audio_zh")}
</Select.Option>
<Select.Option value="ja">
  {t("video.audio_ja")}
</Select.Option>
<Select.Option value="ko">
  {t("video.audio_ko")}
</Select.Option>

<Select.Option value="ru">
  {t("video.audio_ru")}
</Select.Option>

    </Select>
      </Col>
    </Row>
  ))}
      
        {/* Submit button for multiple mode */}
        {isMultipleMode && multiUploadedFiles.length > 0 && (
          <Button
            type="primary"
            style={{ marginTop: 20 ,float:"right"}}
            onClick={handleMultipleSubmit}
          >
            {t("video.confirm_multiple_upload")}
          </Button>
        )}
      
    
      </>
      ),
    },
    {
      id: 2,
      title: (
        <span has-permission="media_video_add_option_on_hold">
          {" "}
          {modules?.media_video_list_dtable_videos_draft ? t("Podcast.videos_draft") : t("video.Medias_en_attente")}
        </span>
      ),
      icon: <PlayCircleFilled />,
      value: <DataTable />,
      permission: modules.media_video_add_option_on_hold,
    },
    {
      id: 3,
      title: (
        <span has-permission="media_video_add_option_extern_link">{`${t(
          "video.Lien"
        )}`}</span>
      ),
      icon: <LinkOutlined />,
      permission: modules.media_video_add_option_extern_link,
      value: (
       <AddUrl />
      ),
    },

    {
      id: 8,
      title: (
        <span has-permission="media_video_add_option_webcam">
          {t("video.camera")}
        </span>
      ),
      icon: <CameraFilled />,
      disabled: true,
      permission: modules.media_video_add_option_webcam,
      value: <></>,
    },
    {
      id: 10,
      title: (
        <span has-permission="media_video_add_option_story_board">
          Storyboard
        </span>
      ),
      icon: <YoutubeFilled />,
      disabled: true,
      permission: modules.media_video_add_option_webcam,
      value: (
        <iframe
          title={storyboardURL}
          className="iframeVideo"
          id="iframe_display"
          src={"https:" + storyboardURL}
          allowFullScreen
        ></iframe>
      ),
    },
  ];
  return (
    <>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div className="upload-page">
          <ArrowLeftOutlined
            style={{
              cursor: "medium",
              padding: "10px",
              margin: 0,
              position: "absolute",
              top: "5px",
              left: "5px",
            }}
            onClick={() => {
              history.push("/ws-media");
              window.parent.postMessage(
                { info: "diffusion", value: "ongoing" },
                "*"
              );
            }}
          />

          <Tabs
            defaultActiveKey={defaultKey}
            activeKey={defaultKey}
            onChange={onKeyChange}
          >
            {exportType &&
              exportType.length &&
              exportType.map(
                (element) =>
                  (isSuperAdmin || element.permission) && (
                    <TabPane
                      disabled={element.disabled}
                      tab={
                        <div>
                          <span>
                            {element.icon}
                            {element.title}
                          </span>
                          <Divider type="vertical" />
                        </div>
                      }
                      key={element.id}
                    >
                      {element.value}
                    </TabPane>
                  )
              )}
          </Tabs>
        </div>
      )}
    </>
  );
};
